import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { setLogout } from '../../Auth/LoginSlice';
import { setActiveKey } from '../ActiveKeySlice';
import { useNavigate } from 'react-router-dom';

const UseActivitiesList = (token, setLoader) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [activityList, setActivityList] = useState([]);

    const getAllActivities = async () => {
        try {
            setLoader(true);
            const response = await fetch(process.env.REACT_APP_BASE_URL + '/priority/titleTypeFilter', {
                method: 'POST',
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({
                    type: "Activity",
                })
            })
            const responseData = await response.json();
            if (responseData.message === "Authorization failed / Forbidden") {
                setLoader(true);
                dispatch(setLogout(null));
                dispatch(setActiveKey(null));
                localStorage.removeItem('persist:root');
                navigate('/');
            } else {
                setActivityList(responseData?.data);
                setLoader(false);
            }

        } catch (Err) {
            console.log("Err while getting activites", Err);
            setLoader(false);
        }
    }


    return { activityList, getAllActivities }
}


export default UseActivitiesList